<template>
    <div class="tab_bar_wrap">
      <div
        class="lable"
        v-for="t in items"
        :key="t.id"
        @click="tab(t)"
        :class="{ on: t.selected }"
      >
        {{ t.name }}
      </div>
      <!-- <div class="lable more" :class="{ on: moreValue !== '更多' }" v-if="moreList.length" @click.stop="showMore()">
          {{ moreValue }}
          <div class="indicate" :class="{ ind_on: moreValue !== '更多' }"></div>
          <transition name="fade">
            <ul class="menu" v-show="isShow">
              <li v-for="item in moreList" :key="item.id" @click.stop="selectedMore(item)">
                {{ item.name}}
              </li>
            </ul>
          </transition>
      </div> -->
    </div>
</template>

<script>
export default{
  props: {
    list: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 4
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShow: false,
      moreList: [],
      items: [],
      moreValue: '更多',
      selectedValue: null,
      gap: 3
    }
  },
  methods: {
    showMore () {
      this.isShow = !this.isShow
    },
    setData () {
      let list = JSON.parse(JSON.stringify(this.list)) || []
      if (!list.length) return
      if (!this.defaultValue) {
        this.defaultValue = list[0].name
      }
      if (list.length > this.limit) {
        let items = list.splice(0, this.limit)
        items.forEach(t => {
          let o = { name: t.name, id: t.id, selected: false }
          if (this.defaultValue === t.name) {
            o.selected = true
          }
          this.items.push(o)
        })
        list.forEach(item => {
          item.extraValue = item.name
          if (item.name && item.name.length > this.gap) {
            item.name = item.name.substr(0, this.gap) + '...'
          }
        })
        this.moreList = list
      } else {
        this.items = list.map(t => {
          let selected = false
          if (this.defaultValue === t.name) selected = true
          return { name: t.name, id: t.id, selected: selected }
        })
      }
    },
    selectedMore (item) {
      this.items.forEach(item => {
        item.selected = false
      })
      this.moreValue = item.extraValue
      this.hide()
      this.selectedValue = item
      // 处理超出字符串
      if (item.extraValue.length >= this.gap) {
        this.moreList.forEach(t => {
          if (t.extraValue.length > item.extraValue.length) {
            t.name = t.name.substr(0, this.gap) + '...'
          } else {
            t.name = t.extraValue
          }
        })
      }
      this.emit()
    },
    tab (t) {
      this.items.forEach(item => {
        item.selected = false
      })
      t.selected = true
      this.moreValue = '更多'
      this.selectedValue = t
      this.emit()
    },
    emit () {
      this.$emit('change', this.selectedValue)
    },
    hide () {
      this.isShow = false
    }
  },
  watch: {
    list (val) {
      this.setData()
    },
    deep: true
  },
  created () {
    this.setData()
    // 点击其他地方隐藏
    document.addEventListener('click', this.hide)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.hide)
  }
}

</script>
<style lang='less' scoped>
.tab_bar_wrap {
  display: inline-block;
  font-size: 0px;
}
.lable {
    font-size: 22px;
    line-height: 38px;
//   border:2px solid rgba(0,255,255,1);
//   padding:0 22px;
//   color:rgba(0,255,255,1);
    background-image: url(https://img.yimutian.com/crm/5ff5a0c22d211f71026cb976005c001e.png);
    background-repeat: no-repeat;
    background-size: 100% 92%;
    -moz-background-size:100% 100%;
    color:#60E0FF;
    padding: 0 10px;
    font-weight:bold;
    display: inline-block;
    cursor: pointer;
    box-sizing: border-box;
}
.lable + .lable {
  margin-left: 24px;
}
.lable.more {
  position: relative;
  .indicate {
    width: 0;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: #00FFFF transparent transparent transparent;
    display: inline-block;
    vertical-align: middle;
    margin-top: 8px;
  }
}
.lable .indicate.ind_on {
  border-color: #060e1e transparent transparent transparent !important;
}
.lable.on {
//   background: #00ffff;
//   color: #060e1e;
    background-image: url(https://img.yimutian.com/crm/5ff5a40fb827730a886c89590072001e.png);
    background-repeat: no-repeat;
    background-size: 100% 92%;
    -moz-background-size:100% 100%;
    padding: 0 10px;
    color:white;
}
.menu {
  position: absolute;
  box-sizing: content-box;
  top: 48px;
  right: -2px;
  border:2px solid rgba(0,255,255,1);
  background:rgba(0,255,255,0.3);
  text-align: center;
  z-index: 99999;
  transition: all .3s;
  margin: 0px;
  padding-left: 0px;
  list-style: none;
  font-size: 22px;
  width: 100%;
    li {
      line-height: 38px;
      font-weight:bold;
      color:rgba(0,255,255,1);
      cursor: pointer;
      &:hover {
        background: rgba(7, 235, 235, 0.3);
      }
    }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
